module.exports = __webpack_public_path__ + "img/dropdown-small.3cd34f69.svg";